<template>
  <div class="input-group me-3">
    <span class="input-group-text">
      <i class="fa fa-search"></i>
    </span>
    <input
      type="text"
      class="form-control"
      :placeholder="placeholder"
      v-model="search"
      @input="$emit('update:modelValue', search)"
    />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
const props = defineProps({
  modelValue: String,
  placeholder: { type: String, default: "Buscar por nombre..." },
});
const search = ref(props.modelValue || "");
watch(
  () => props.modelValue,
  (v) => (search.value = v)
);
</script>
